import { render } from "./UserRewardLeaderboards.vue?vue&type=template&id=7097094c"
import script from "./UserRewardLeaderboards.vue?vue&type=script&lang=js"
export * from "./UserRewardLeaderboards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__